import styled from 'styled-components';
import UpcomingSvg from '../../assets/mytrips/upcoming.svg';

const UpcomingIcon = styled(UpcomingSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '3.2rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default UpcomingIcon;
